module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/60c8d046c7b5d074b5dc5dd82b340b5d.png";